/* eslint-disable */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import EmailIcon from "@mui/icons-material/Email";
import Button from "@mui/material/Button";
import Doctor from "../../doctors.svg";

import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { Provider } from "react-redux";

import { loginSuccess, addUser } from "../../redux/authRedux";
import Swal from "sweetalert2";
import { MouseEvent } from "react";
// import { useSelector } from 'react-redux'
// const uri = 'http://localhost:9000/api/'
import CherryK from "../../assets/img/cherryk.png";
import BASE_API_URL from "../../api/api";
import apiInstance from "../../Utils/api";

const Login = () => {
  const url = BASE_API_URL;
  // console.log(url, 'login url')
  const [showPassword, setShowPassword] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const Id = localStorage.getItem("Id");
  const Name = localStorage.getItem("Name");

  // console.log(Name, 'Con Name')

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  const handleClickShowEmail = () => setShowEmail((show) => !show);

  const handleMouseDownEmail = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const setlogin = () => {
    event.preventDefault();
    setLoading(true);
    console.log(password, "password");
    const data = {
      email: email,
      password: password,
    };

    const api = apiInstance

    api
      .post("auth/login", data)
      .then(function (response) {
        // console.log(response.data, 'data')
        dispatch(loginSuccess(response.data));
        dispatch(addUser(response.data));
        if (
          response.data.user.role === "Admin" &&
          response.data.isAdmin === true
        ) {
          Swal.fire({
            title: "Success",
            text: "successfully Login!",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
          navigate("/category");
          window.location.reload();
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("Id", response.data._id, "Id");
          localStorage.setItem("role", response.data.user.role);
          localStorage.setItem("Name", response.data.user.name);
        } else if (
          response.data.user.role === "Website" &&
          response.data.isUser === true
        ) {
          Swal.fire({
            title: "Success",
            text: "successfully Login!",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
          navigate("/treatment-dashboard");
          window.location.reload();
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("Id", response.data._id, "Id");
          localStorage.setItem("Name", response.data.user.name);
          localStorage.setItem("role", response.data.user.role);
        } else {
          Swal.fire({
            title: "Something Wrong",
            text: "Please try again!",
            icon: "error",
            showConfirmButton: false,
            timer: 5000,
          });
          navigate("/");
        }
      })

      // console.log(response.data.user.name, 'name')

      .catch((error) => {
        setLoading(false)
        Swal.fire({
          title: "Error",
          text: "Something Wrong Email or Password!",
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
      });
  };
  return (
    <div className='row'>
      <div className='col-7 ' style={{ marginTop: "40px" }}>
        <img src={Doctor} alt='' width='850px' height='550px' />
      </div>

      <div className='col-3 '>
        <div style={{ marginTop: "100px" }}>
          <img src={CherryK} alt='' width='400px' height='220px' />

          <b
            style={{
              fontSize: "15px",
              fontFamily: "serif",
              marginLeft: "5em",
            }}
            className='row'
          >
            Hello , Please Sign In to Your Account!
          </b>

          <div>
            <form onSubmit={setlogin} style={{ marginLeft: "5em" }}>
              <div className='mt-3'>
                <FormControl sx={{ m: 1, width: "40ch" }} variant='outlined'>
                  <InputLabel htmlFor='outlined-adornment-email'>
                    Email
                  </InputLabel>
                  <OutlinedInput
                    id='outlined-adornment-email'
                    type={showEmail ? "text" : "email"}
                    endAdornment={
                      <InputAdornment position='end'>
                        <IconButton
                          aria-label='toggle email visibility'
                          onClick={handleClickShowEmail}
                          onMouseDown={handleMouseDownEmail}
                          edge='end'
                        >
                          {showEmail ? <EmailIcon /> : <EmailIcon />}
                        </IconButton>
                      </InputAdornment>
                    }
                    value={email}
                    label='Email'
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </FormControl>
              </div>
              <div className='mt-2'>
                <FormControl sx={{ m: 1, width: "40ch" }} variant='outlined'>
                  <InputLabel htmlFor='outlined-adornment-password'>
                    Password
                  </InputLabel>
                  <OutlinedInput
                    id='outlined-adornment-password'
                    type={showPassword ? "text" : "password"}
                    endAdornment={
                      <InputAdornment position='end'>
                        <IconButton
                          aria-label='toggle password visibility'
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge='end'
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label='Password'
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </FormControl>
              </div>
              <Button
                type='submit'
                variant='contained'
                sx={{
                  m: 1,
                  width: "36ch",

                  marginTop: "20px",
                }}
                disabled={loading}
              >
                {
                  loading ? "Loading..." : "Login"
                }
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
